import CMS from "netlify-cms-app";
import cloudinary from "netlify-cms-media-library-cloudinary";

import config from "./config";

import RTLMarkdownWidget from "./widgets/RTLMarkdownWidget/RTLMarkdownWidget";
import PostIdWidget from "./widgets/PostIdWidget/PostIdWidget";
import YoutubeEditorComponent from "./widgets/YoutubeEditorComponent";
import AboutPagePreview from "./preview-templates/AboutPagePreview";
// import SimplePagePreview from "./preview-templates/SimplePagePreview";
import BlogPostPreview from "./preview-templates/BlogPostPreview";
import ProductPagePreview from "./preview-templates/ProductPagePreview";
import IndexPagePreview from "./preview-templates/IndexPagePreview";
import EventPagePreview from "./preview-templates/EventPagePreview";
import GlossaryItemPagePreview from "./preview-templates/GlossaryItemPagePreview";
import LibraryItemPagePreview from "./preview-templates/LibraryItemPagePreview";

CMS.registerWidget(RTLMarkdownWidget.name, RTLMarkdownWidget.ControlComponent, RTLMarkdownWidget.PreviewComponent);
CMS.registerWidget(PostIdWidget.name, PostIdWidget.ControlComponent, PostIdWidget.PreviewComponent);


// CMS.registerMediaLibrary(uploadcare);
CMS.registerMediaLibrary(cloudinary);

CMS.registerPreviewTemplate("index", IndexPagePreview);
CMS.registerPreviewTemplate("blog", BlogPostPreview);
CMS.registerPreviewTemplate("about", AboutPagePreview);
CMS.registerPreviewTemplate("products", ProductPagePreview);
CMS.registerPreviewTemplate("events", EventPagePreview);
CMS.registerPreviewTemplate("glossary", GlossaryItemPagePreview);
CMS.registerPreviewTemplate("library", LibraryItemPagePreview);

CMS.registerPreviewTemplate("blog-index", IndexPagePreview);
CMS.registerPreviewTemplate("products-index", IndexPagePreview);
CMS.registerPreviewTemplate("library-index", IndexPagePreview);
CMS.registerPreviewTemplate("services-index", IndexPagePreview);


CMS.registerEditorComponent(YoutubeEditorComponent);

//todo: events index
//todo: contact
//todo: blog tags index
//todo: products tags index
//todo: events tags index

CMS.init({
	config
});
